import { NgModule,ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { RouterModule } from "@angular/router";
import { MaterialModule } from "../../components/material/material.module";
import { CrearInformeComponent } from "./crear-informe/crear-informe.component";
import { CrearInformeDialog } from "./crear-informe/crear-informe-dialog/crear-informe-dialog.component";
import { InformePersonalizadoService } from "../../providers/informe-personalizado.service";
import { VerInformesComponent } from "./ver-informes/ver-informes.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        RouterModule,
        MaterialModule,       
        MatProgressSpinnerModule
 
    ],
    declarations: [
        CrearInformeComponent,
        CrearInformeDialog,
        VerInformesComponent
    ],
    providers: [
        InformePersonalizadoService,
      
    ],
    entryComponents: [
        CrearInformeDialog,
    ],
    exports: [
        CrearInformeComponent,
        VerInformesComponent
    ]
})
export class InformeModule { }